import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ROUTES from '../../../../constants/ROUTES';
import SearchInput from '../../../Input/SearchInput';
import Button from '../../../Button';

import plusIcon from '../../../../assets/Plus.svg';
import searchIcon from '../../../../assets/SearchGray.svg';
import ListIconWhite from '../../../../assets/ListIconWhite.svg';

import scrollbarStyle from '../../../../scrollbar.module.css';
import GoAroundLoader from '../../../Loader/GoAroundLoader';
import {
  fetchProfiles,
  setProfileList
} from '../../../../redux/slices/profile';

const ProfileTab = ({ closeModal }) => {
  const dispatch = useDispatch();

  const { profileList, loading: isProfileLoading } = useSelector(
    (state) => state.profile
  );

  const navigation = useNavigate();
  const [searchText, setSearchText] = useState(null);

  //   Search
  const handleChangeSearchText = (e) => {
    setSearchText(e?.target?.value);
  };

  const handleSearchProfile = (searchInput) => {
    dispatch(fetchProfiles(searchInput));
  };

  // throttle
  useEffect(() => {
    const throttleTimeout = setTimeout(() => {
      if (searchText !== null && searchText !== '') {
        handleSearchProfile(searchText);
      } else {
        dispatch(setProfileList([]));
      }
    }, 200);

    return () => {
      clearTimeout(throttleTimeout);
    };
  }, [searchText]);

  return (
    <div className='flex flex-col h-full gap-y-2'>
      <Button
        icon={plusIcon}
        title={'New Partner Profile'}
        iconStyle={'mr-2'}
        textStyle={'text-sm'}
        buttonStyle={'rounded-lg'}
        handleClick={() => {
          closeModal();
          navigation(ROUTES.newProfile);
        }}
      />

      <div className='flex flex-row relative w-full'>
        <Button
          icon={ListIconWhite}
          title={'View all Partner Profiles'}
          iconStyle={'mr-2'}
          textStyle={'text-sm'}
          buttonStyle={'rounded-lg w-full'}
          handleClick={() => {
            closeModal();
            navigation(ROUTES.allProfiles);
          }}
        />

        <div className='absolute right-0 flex flex-col h-full justify-center mr-2'>
          <button
            className='bg-white/10 hover:bg-white/20 px-[2.5px] py-1 rounded'
            onClick={(e) => {
              e.stopPropagation();
              closeModal();
              navigation(`${ROUTES.allProfiles}/goToSearch`);
            }}
          >
            <img src={searchIcon} className='w-[20px]' alt='Search' />
          </button>
        </div>
      </div>

      <div className='border-b border-neutral-600 pt-1.5' />

      <div className='my-2'>
        <SearchInput
          placeholder={'Quick Search'}
          handlechangesearch={handleChangeSearchText}
          value={searchText}
        />
      </div>

      <div
        className={`h-full overflow-y-auto w-full ${scrollbarStyle.customScrollLight}`}
      >
        {isProfileLoading && (
          <div className='flex flex-col justify-center items-center'>
            <GoAroundLoader height={50} width={50} color={'white'} />
          </div>
        )}
        {searchText?.length ? (
          profileList?.length ? (
            <>
              <div className='flex flex-col gap-y-1'>
                {profileList.map((profile, index) => (
                  <button
                    onClick={() => {
                      closeModal();
                      navigation(`${ROUTES.profile}/${profile.id}`);
                    }}
                    key={index}
                    className='flex flex-row justify-between p-2 rounded items-center hover:bg-neutral-200/10 w-full'
                  >
                    <span className='text-white select-none text-sm truncate'>
                      {profile.name}
                    </span>
                  </button>
                ))}
              </div>
            </>
          ) : !isProfileLoading ? (
            <div className='flex justify-center items-center my-4 text-neutral-200'>
              No profiles found
            </div>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ProfileTab;
